import styled from "@emotion/styled";
import { SolanaMobileWalletAdapterWalletName } from "@solana-mobile/wallet-adapter-mobile";
import { BaseButton } from "@stepfinance/react";
import { Dropdown } from "antd";
import type { MouseEventHandler } from "react";
import React, { useCallback } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useLanguageContext } from "../../contexts/language/language";
import { useWalletModal } from "../WalletModal/useWalletModal";
import { WalletMenuConnected } from "./WalletMenuConnected";

interface WalletConnectProps {
  isMobile?: boolean;
  children?: React.ReactNode;
}

export const WalletConnect: React.FC<WalletConnectProps> = ({ children, isMobile }) => {
  const { connected, connect, wallet } = useEnrichedWallet();
  const { setVisible } = useWalletModal();

  const handleWalletSelect: MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      if (!event.defaultPrevented) {
        if (wallet?.adapter.name === SolanaMobileWalletAdapterWalletName) {
          void connect();
        } else {
          setVisible(true);
        }
      }
    },
    [connect, setVisible, wallet?.adapter.name],
  );

  const {
    currentLanguageData: {
      pages: {
        allPages: { topBar },
      },
    },
  } = useLanguageContext();

  if (connected) {
    return (
      <Dropdown
        placement="bottomRight"
        overlay={<WalletMenuConnected />}
        overlayStyle={{
          paddingTop: "18px",
        }}
        trigger={["click"]}
        mouseEnterDelay={0}
      >
        <div>{children}</div>
      </Dropdown>
    );
  }

  return (
    <ConnectButtonContainer>
      <BaseButton onClick={wallet?.adapter.publicKey ? connect : handleWalletSelect}>
        {isMobile ? topBar.walletButton.orConnectWallet : topBar.walletButton.connectWallet}
      </BaseButton>
    </ConnectButtonContainer>
  );
};

const ConnectButtonContainer = styled.div`
  button {
    border-radius: 8px;
    width: 125px;
    span {
      font-size: 14px;
    }
  }
`;
